import {
  Component,
  Inject,
  PLATFORM_ID,
  OnInit,
  inject,
  HostListener,
} from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { SeoService } from './shared/services/seo-service.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { EnvironmentService } from './shared/services/environment.service';
import { SharedService } from './shared/services/shared.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  private isBrowser: boolean;
  isScrolled = false;
  sharedService = inject(SharedService);
  env = inject(EnvironmentService);

  constructor(
    public translate: TranslateService,
    @Inject(PLATFORM_ID) private platformId: object,
    private router: Router,
    private seoService: SeoService,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      const isInit = localStorage.getItem('init');

      if (!isInit) {
        localStorage.removeItem('departingAirports');
        localStorage.removeItem('landingAirports');
        localStorage.removeItem('hotelform');
        localStorage.removeItem('form');
        localStorage.setItem('init', '1');
      }
    }

    this.setLanguage();
    this.updateMetaTagsForInitialRoute();
    this.subscribeToRouterEvents();

    let envtrvyl = {
      offlineSeats:"https://41.223.55.14:7025",
      searchflow:  'https://flightsearch.Abousamratravel.com',
      BookingFlow:  'https://flightflow.Abousamratravel.com',
      FareRules:  'https://flightprov.Abousamratravel.com',
      asm:  'https://backofficeapi.Abousamratravel.com',
      Apihotels:  "https://hotels.Tazkrticom",
      users:  'https://usersapi.Abousamratravel.com',
      admin:  'https://adminapi.Abousamratravel.com/',
      getDPayment:  'https://adminapi.Abousamratravel.com/',
      bookHotels: "https://hotels.Abousamratravel.com",
      prepay: 'https://prepayapi.Abousamratravel.com',
      backOffice: 'https://backofficeapi.Abousamratravel.com',
      FlightTop:'https://flightsearch.Abousamratravel.com',
      offers: {
        getAll: 'https://41.215.243.36:7893/api/GetAllOffersAPI?POS=',
        getByID: 'https://41.215.243.36:7893/api/GetOfferByIdAPI?OfferId=',
        BookOffer: "https://41.215.243.36:7895/api/BookOffer",
        RetriveItineraryDetails:'/api/Admin/RetriveItineraryDetails'
      }
    }

    this.env.envConfiguration(envtrvyl);
  }

  private setLanguage(): void {
    if (this.isBrowser) {
      const savedLang = localStorage.getItem('lang') || 'en';
      this.translate.use(savedLang);
      this.document.dir = savedLang === 'en' ? 'ltr' : 'rtl';
    } else {
      this.translate.use('en');
      this.document.dir = 'ltr';
    }
  }

  private updateMetaTagsForInitialRoute(): void {
    const urlSegments = this.router.url.split('/');
    const airlineCode = urlSegments[2]; // Assuming the URL is /airlines/:airlineCode
    const lang = this.isBrowser ? localStorage.getItem('lang') || 'en' : 'en';

    if (airlineCode) {
      this.seoService.updateMetaTags(airlineCode, lang);
    }
  }

  private subscribeToRouterEvents(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (this.isBrowser) {
          const lang = localStorage.getItem('lang') || 'en';
          const urlSegments = event.url.split('/');
          const airlineCode = urlSegments[2]; // Assuming the URL is /airlines/:airlineCode

          if (airlineCode) {
            this.seoService.updateMetaTags(airlineCode, lang);
          }
        }
      });
  }

  onClickWhatsappBtn() {
    window.open('https://wa.me/+201021042488', '_blank');
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    this.isScrolled = scrollPosition > 0;
  }

  get lang() {
    return this.translate.currentLang;
  }
}
